<template>
  <div class="participant-activity-response">
    <div v-if="participantResponses && participantResponses.length > 0 && questionDetails">
      <!-- Column Headers Question and Answer and the Edit button -->

      <div class="que-ans-heading d-flex align-items-center">
        <div class="que-ans-heading__left">
          <span class="fs-12 font-w-bold color-black">Question</span>
        </div>
        <div class="que-ans-heading__line bg-white"></div>
        <div class="que-ans-heading__right d-flex justify-content-between">
          <div class="que-ans-heading__ans">
            <span class="fs-12 font-w-bold color-black">Answer</span>
          </div>
          <div class="que-ans-heading__edit">
            <div v-if="isDisplayEditButton">
              <button class="edit-btn-after pt-1 d-flex align-items-center justify-content-center" v-on:click="getIntoEditMode" v-if="!isEditModeActive && surveyResponseStatus && surveyResponseStatus.lock_status === 'UNLOCKED'">
                <img src="static/img/noneditpencile.png" alt="Pencil" />
                <span class="edit-btn-after-text">EDIT</span>
              </button>
              <button v-else-if="isEditModeActive && surveyResponseStatus && surveyResponseStatus.lock_status === 'UNLOCKED'" class="edit-btn d-flex align-items-center justify-content-center">
                <img src="static/img/editpencile.png" alt="Pencil" />
                <span class="edit-btn-text">EDIT</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- for Activities  -->
      <div v-if="surveyData.activityId">
        <ParticipantActivityResponsePreview
          :participantResponses="participantResponsesFilteredForDisplay"
          :questionDetails="questionDetails"
          :questionDetailsObj="questionDetailsObj"
          :questionDetailsFiltered="questionDetailsFiltered"
          :activityType="surveyData.activityId ? 'activity' : 'survey'"
          :mode="isEditModeActive ? 'EDIT' : 'PREVIEW'"
          :validations="validations"
          :lockStatus="surveyResponseStatus && surveyResponseStatus.lock_status"
          :activityLanguageCulture="activityLanguageCulture"
          :selectedLanguageCulture="selectedLanguageCulture"
          @answerChanged="setTempAns"
          @updateSectionScores="updateSectionScores"
          :tempEditedAnswers="tempEditedAnswers"
          :surveyData="surveyData"
          :questionsMLOptions="questionsMLOptions"
          :questionIdToCustomLabels="questionIdToCustomLabels"
          :questionIdToNumberScaleLabels="questionIdToNumberScaleLabels"
          :userRoles="userRoles"
          @openNewQuery="createNewQuery"
          @selectField="selectField"
          :openQueriesToQuestionMap="openQueriesToQuestionMap"
          :selectedQuestionId="selectedQuestionId"
        />
      </div>
      <!-- for Legacy Surveys -->
      <div v-else>
        <ParticipantSurveyResponsePreview
          :participantAnswers="participantResponsesFilteredForDisplay"
          :questionDetailsObj="questionDetailsObj"
          :mode="isEditModeActive ? 'EDIT' : 'PREVIEW'"
          :validations="validations"
          :lockStatus="surveyResponseStatus && surveyResponseStatus.lock_status"
          :activityLanguageCulture="activityLanguageCulture"
          :selectedLanguageCulture="selectedLanguageCulture"
          @answerChanged="setTempAns"
          :tempEditedAnswers="tempEditedAnswers"
          :activityType="surveyData.activityId ? 'activity' : 'survey'"
          :surveyData="surveyData"
          :questionsMLOptions="questionsMLOptions"
          :questionIdToCustomLabels="questionIdToCustomLabels"
          :questionIdToNumberScaleLabels="questionIdToNumberScaleLabels"
          :userRoles="userRoles"
          @openNewQuery="createNewQuery"
          @selectField="selectField"
          :openQueriesToQuestionMap="openQueriesToQuestionMap"
          :selectedQuestionId="selectedQuestionId"
        />
      </div>
      <div class="m-25 d-flex justify-content-end" v-if="isEditModeActive">
        <button class="cancel-edit-btn" @click="onEditCancel">
          <span class="cancel-edit-btn-text">Cancel</span>
        </button>
        <button class="save-btn" @click="showConfirmEditModal">
          <span class="save-btn-text">Save</span>
        </button>
      </div>
    </div>

    <b-modal ref="editResponseModal" size="lg" hide-footer hide-header>
      <div class="modal-content-box p-25">
        <b-container fluid>
          <b-row class="text-center mb-25">
            <b-col><span class="font-weight-bold fs-18 change-reason-text">Select a reason for the change.</span></b-col>
          </b-row>
          <b-row class="text-center mb-35">
            <b-col>
              <b-form-select v-model="changeReason" class="browser-default custom-select">
                <template slot="first">
                  <option :value="''" disabled>Select an option</option>
                </template>
                <option v-for="opt in changeReasonOptions" :key="opt" :disabled="!queries.length && opt === 'Per Query Resolution'">{{ opt }}</option>
              </b-form-select>
            </b-col>
          </b-row>

          <b-row class="text-center mb-35" v-if="changeReason == 'Per Query Resolution'">
            <b-col>
              <b-row v-if="selectedQuery" class="selectBox selectedBox">
                <span class="d-inline-block truncate selected-filter" @click="showQueries">{{ selectedQueryName }}</span>
              </b-row>
              <b-row class="selectBox" @click="showQueries" v-else>
                <select class="query-type-select">
                  <option value selected="selected">Select Query</option>
                </select>
                <b-row class="overSelect"></b-row>
              </b-row>
              <b-row v-if="isDisplayQuery" id="showQueries">
                <b-form-input type="text" class="query-search-bar" placeholder="Search for query" v-model="searchedQuery"> </b-form-input><br />
                <div class="query-list" v-for="query in searchedQueryList" :key="query.id" @click="getSelectedQuery(query)">
                  <label
                    ><strong>{{ query.sequence_no }} {{ query.created_by }}</strong></label
                  ><br />
                  <label class="truncate"
                    ><small>{{ query.query_content }}</small></label
                  >
                </div>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="text-center justify-content-center">
            <button type="button" class="cancel-confirm-btn" v-on:click="hideConfirmEditModal">
              <span class="cancel-confirm-btn-text">Cancel</span>
            </button>
            <button type="button" class="confirm-change" :disabled="isPostEditAnswerAPICallInProgress || (changeReason === 'Per Query Resolution' && !selectedQuery) || !changeReason" v-on:click="onEditConfirm">
              <span class="confirm-change-text">Confirm data change</span>
            </button>
          </b-row>
        </b-container>
      </div>
    </b-modal>

    <b-modal ref="branchingWarning" hide-footer hide-header>
      <div class="branching-modal-content">
        <b-container fluid>
          <b-row class="text-right justify-content-end">
            <b-col cols="12">
              <button type="button" class="close close-button" @click="hideBranchingWarningModal(false)">&times;</button>
            </b-col>
          </b-row>
          <b-row class="text-center branching-warning-content">
            <b-col
              ><span class="fs-18 branching-warning-text"> <b>Note:</b> Branching logic is not enabled when editing responses, and edits are only permitted for questions that were not previously skipped. </span></b-col
            >
          </b-row>
          <b-row class="text-center justify-content-center">
            <b-col cols="4">
              <b-btn class="btn-block fs-14 branching-modal-cancel-btn" variant="outline-primary" v-on:click="hideBranchingWarningModal(false)"> Cancel </b-btn>
            </b-col>
            <b-col cols="4">
              <b-btn class="btn-block fs-14 branching-modal-continue-btn" variant="primary" v-on:click="hideBranchingWarningModal(true)"> Continue </b-btn>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import ParticipantActivityResponsePreview from "./participant-activity-response-preview";
import ParticipantSurveyResponsePreview from "./participant-survey-response-preview";

// To implement the cancel and save functionality, we will be needing two objects. When in edit mode, the cloned object
// will get edited and if cancled, we will be needing the original answers which will always be _participantAnswers
// _particpantAnswers is the prop and will never be modfied, that is the original answers by the paticipant
// We will also loop with the cloned version and on cancel, we will again clone the original response.

// _participantResponses -> Original answers which will never be modified
// participantResponses ->  DEEP CLONED version of _participantResponses which will get modified and get sent to backend on save
// participantResponsesFilteredForDisplay -> NOT cloned version of participantResponses, filtered array which will not have surveyinstruction type but
// each answer is a reference to partipantRespones. Change in any of object in participantResponsesFilteredForDisplay will be reflected in partiicpantResponses

export default {
  name: "editable-participant-activity-response",
  props: ["_participantResponses", "questionDetails", "userRoles", "selectedQuestionId", "openQueriesToQuestionMap", "surveyData", "activityLanguageCulture", "selectedLanguageCulture", "isEditModeActive", "isPostEditAnswerAPICallInProgress", "questionsMLOptions", "questionIdToCustomLabels", "questionIdToNumberScaleLabels", "totalScore", "studyData", "queries", "surveyResponseStatus"],
  data() {
    return {
      selectedQueryName: "",
      searchedQuery: "",
      isDisplayQuery: false,
      selectedQuery: "",
      participantResponses: null,
      tempEditedAnswers: {},
      defaultDateFormat: "DD/MM/YYYY",
      changeReasonOptions: ["Data Entry Error", "Per Query Resolution", "New Information"],
      questionDetailsFiltered: [],
      changeReason: "Data Entry Error",
      ANSWER_TEXT: "answerText",
      DISPLAY_ANSWER_TEXT: "displayAnswerText",
      validations: {},
      questionIdToParticipantResponseMap: {}
    };
  },
  components: {
    ParticipantActivityResponsePreview,
    ParticipantSurveyResponsePreview
  },

  computed: {
    searchedQueryList() {
      if (!this.queries) {
        return [];
      }
      if (!this.queries.length) {
        return [];
      }
      const queries = this.queries.filter(query => {
        return query.created_by.toLowerCase().includes(this.searchedQuery) || query.query_content.toLowerCase().includes(this.searchedQuery) || query.sequence_no.toString().includes(this.searchedQuery);
      });
      return _.sortBy(queries, "created_by");
    },
    user() {
      return this.$store.getters.user;
    },

    JsonFieldToDisplay() {
      if (this.isEditModeActive) {
        return this.DISPLAY_ANSWER_TEXT;
      }

      if (this.selectedLanguageCulture === "EN") {
        return this.ANSWER_TEXT;
      } else {
        return this.DISPLAY_ANSWER_TEXT;
      }
    },

    isDisplayEditButton() {
      if (!this.userRoles) {
        return false;
      }

      const { canPiAccess, canSubPiAccess, canStudyCoordinatorAccess, canHomeHealthAccess, canCallCenterAccess } = this.userRoles;

      const isCorrectUser = canPiAccess || canSubPiAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess;
      const isEditCheckAllowed = this.surveyData && this.surveyData.editCheckAllowed;
      const isCorrectLanguage = this.selectedLanguageCulture === this.activityLanguageCulture;

      if (isCorrectUser && isEditCheckAllowed && isCorrectLanguage && !this.user.readOnly) {
        return true;
      }
      return false;
    },
    // questionsDetailsObj will be a object where key is the questionId and the value will be that question's complete Details
    questionIdToMLOptions() {
      if (!this.questionsMLOptions || Object.keys(this.questionsMLOptions).length === 0) {
        return null;
      }

      const questionOptions = {};
      this.questionsMLOptions.forEach(question => {
        questionOptions[question.id] = question;
      });

      return _.cloneDeep(questionOptions);
    },

    questionDetailsObj() {
      if (!this.questionDetails) {
        return null;
      }

      const questionDetailsObj = {};
      this.questionDetails.forEach(question => {
        questionDetailsObj[question.id] = question;
      });

      return _.cloneDeep(questionDetailsObj);
    },

    participantResponsesFilteredForDisplay() {
      this.getUpdatedQuestionResponses();
      const responses = this.participantResponses.filter(response => {
        if (response.questionType.toLowerCase() === "surveyinstruction") {
          return true;
        }

        if (this.doesQuestionExistsInSurveyJson(response.questionId)) {
          return true;
        } else {
          return false;
        }
      });

      return _.cloneDeep(responses);
    }
  },

  watch: {
    selectedLanguageCulture: {
      handler() {
        this.cloneDeepParticipantResponses();
      }
    },
    _participantResponses: {
      handler() {
        this.cloneDeepParticipantResponses();
        this.setTempInitialValues();
        this.$forceUpdate();
      },
      deep: true
    },
    isEditModeActive() {
      if (this.isEditModeActive) {
        this.$emit("editModeActive");
      }
    }
  },

  mounted() {
    this.cloneDeepParticipantResponses();
    this.setTempInitialValues();
    this.filterQuestionDetails();
    this.updateSectionScores();
    if (this.surveyData.activityId) {
      this.findMissingAnswers(this.questionDetails, this.participantResponses);
    }
  },

  methods: {
    getSelectedQuery(query) {
      this.selectedQuery = query.id;
      this.selectedQueryName = query.sequence_no + " " + query.created_by;
      this.isDisplayQuery = false;
    },
    showQueries() {
      this.isDisplayQuery = !this.isDisplayQuery;
      this.searchedQuery = "";
    },
    selectField(question) {
      this.$emit("selectField", question);
    },
    doesQuestionExistsInSurveyJson(quesId) {
      if (this.questionDetailsObj && this.questionDetailsObj[quesId]) {
        return true;
      }
      return false;
    },
    updateSectionScores() {
      const activity = _.cloneDeep(this.surveyData);
      activity.questions = this.questionDetailsFiltered;
    },
    filterQuestionDetails() {
      // used to Display Questions in PDEC
      this.questionDetailsFiltered = this.questionDetails.filter(item => {
        return item.type != "Measurements" && item.type != "Index" && item.type != "Log" && item.type != "ValidatedEntry" && item.type != "SurveyCompletion";
      });
    },

    validateFields() {
      return Object.values(this.validations).every(field => field);
    },

    showConfirmEditModal() {
      let hasError = false;
      if (this.surveyData.activityId) {
        this.questionDetailsFiltered.forEach(item => {
          if (item.hasFieldError) {
            hasError = true;
          }
        });
        if (hasError) {
          return;
        }
      } else {
        _.map(this.questionDetailsObj, function (value) {
          if (value.hasFieldError) {
            hasError = true;
          }
        });
      }

      this.$validator.validateAll().then(valid => {
        if (valid && this.validateFields() && !hasError) {
          this.$refs.editResponseModal.show();
        }
      });
    },
    setTempAns(tempAns) {
      if (this.surveyData.activityId) {
        const participantResponses = tempAns.participantResponses;
        if(Array.isArray(participantResponses)){
          for(let i = 0; i < participantResponses.length; i++){
            const participantResponse = participantResponses[i]
            const parentParticipantResponse = this.participantResponses.find(p => p.questionId === participantResponse.questionId)
            const pIndex = this.participantResponses.findIndex(p => p.questionId === participantResponse.questionId)
            if(parentParticipantResponse && !_.isEqual(participantResponse, parentParticipantResponse)){
              this.$set(this.participantResponses, pIndex, participantResponse);
            }
          }
        }
        this.tempEditedAnswers = tempAns.tempEditedAnswers;
      }
    },
    hideConfirmEditModal() {
      this.changeReason = "";
      this.selectedQuery = "";
      this.isDisplayQuery = false;
      this.$refs.editResponseModal.hide();
    },
    setDateInitalTempValues(response, questionId, isDateTime, isEmpty) {
      this.tempEditedAnswers[questionId].date = {};

      if (isEmpty) {
        this.tempEditedAnswers[questionId].date.date = "";
        this.tempEditedAnswers[questionId].date.month = "";
        this.tempEditedAnswers[questionId].date.year = "";

        return;
      }

      const momentDate = isDateTime ? moment(response) : moment(response, "YYYY-MM-DD");

      this.tempEditedAnswers[questionId].date.date = momentDate.date();
      this.tempEditedAnswers[questionId].date.month = momentDate.month();
      this.tempEditedAnswers[questionId].date.year = momentDate.year();
    },

    setTimeInitalTempValues(response, questionId, isDateTime, timeFormat, isEmpty) {
      this.tempEditedAnswers[questionId].time = {};
      this.tempEditedAnswers[questionId].time.value = {};

      if (isEmpty) {
        this.tempEditedAnswers[questionId].time.value.mm = "";
        this.tempEditedAnswers[questionId].time.value.ss = "";

        if (timeFormat == 12) {
          this.tempEditedAnswers[questionId].time.value.hh = "";
          this.tempEditedAnswers[questionId].time.value.A = "";
        } else if (timeFormat == 24) {
          this.tempEditedAnswers[questionId].time.value.HH = "";
        }

        return;
      }

      let timeSplit;

      if (isDateTime) {
        let timeFormatted;
        const momentDate = moment(response);

        if (timeFormat == 12) {
          timeFormatted = momentDate.format("hh:mm A");
        } else if (timeFormat == 24) {
          timeFormatted = momentDate.format("HH:mm");
        }

        timeSplit = timeFormatted.split(":");
      } else {
        timeSplit = response.split(":");
      }

      if (timeFormat == 12) {
        this.tempEditedAnswers[questionId].time.value.hh = timeSplit[0] || "";
        this.tempEditedAnswers[questionId].time.value.mm = timeSplit[1] || "";
        const [ss, A] = timeSplit[2] ? timeSplit[2].split(" ") : ["", ""];
        this.tempEditedAnswers[questionId].time.value.ss = ss;
        this.tempEditedAnswers[questionId].time.value.A = A;
      } else if (timeFormat == 24) {
        this.tempEditedAnswers[questionId].time.value.HH = timeSplit[0] || "";
        this.tempEditedAnswers[questionId].time.value.mm = timeSplit[1] || "";
        this.tempEditedAnswers[questionId].time.value.ss = timeSplit[2] || "";
      }
    },
    setInitalTempValuesForDateTime(questionId, response, isEmpty) {
      const question = this.questionDetailsObj[questionId];

      if (question.showDate && question.showTime) {
        const timeFormat = question.timeFormat;

        this.setDateInitalTempValues(response, questionId, true, isEmpty);
        this.setTimeInitalTempValues(response, questionId, true, timeFormat, isEmpty);
      } else if (question.showDate) {
        this.setDateInitalTempValues(response, questionId, false, isEmpty);
      } else if (question.showTime) {
        const timeFormat = question.timeFormat;

        this.setTimeInitalTempValues(response, questionId, false, timeFormat, isEmpty);
      }
    },
    setTempInitialValues() {
      if (!this.participantResponses) {
        return;
      }

      this.participantResponses.forEach(response => {
        const question = this.questionDetailsObj[response.questionId];
        if (!question) {
          return;
        }

        this.$set(this.tempEditedAnswers, response.questionId, null);

        // VALIDATIONS

        this.$set(this.validations, response.questionId, true);

        // DATE TIME

        if (question.type.toLowerCase() === "datetime") {
          this.tempEditedAnswers[response.questionId] = {};

          const isEmpty = !response.displayAnswerText;

          this.setInitalTempValuesForDateTime(response.questionId, response.displayAnswerText, isEmpty);
        }

        // MULTICHOICE

        if (question.type.toLowerCase() === "multichoice") {
          // MULTI
          if (this.getQuestionSubType(response.questionId) === "Multi") {
            if (!response.optionId) {
              this.tempEditedAnswers[response.questionId] = [];
            } else {
              this.tempEditedAnswers[response.questionId] = response.optionId.split(",");
            }
          }

          // SINGLE
          if (this.getQuestionSubType(response.questionId) === "Single") {
            this.tempEditedAnswers[response.questionId] = response.optionId;
          }
        }

        // IMAGE

        if (question.type.toLowerCase() === "image") {
          // MULTI
          if (this.getQuestionSubType(response.questionId) === "Multi") {
            if (!response.optionId) {
              this.tempEditedAnswers[response.questionId] = [];
            } else {
              this.tempEditedAnswers[response.questionId] = response.optionId.split(",");
            }
          }

          // SINGLE
          if (this.getQuestionSubType(response.questionId) === "Single") {
            this.tempEditedAnswers[response.questionId] = response.optionId;
          }
        }

        // BOOLEAN

        if (question.type.toLowerCase() === "boolean") {
          this.tempEditedAnswers[response.questionId] = response.optionId;
        }

        // CUSTOM SCALE
        if (question.type.toLowerCase() === "customscale") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }
        // TEXT
        if (question.type.toLowerCase() === "text") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }
        // NUMBER
        if (question.type.toLowerCase() === "number") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }
        // DROPDOWN
        if (question.type.toLowerCase() === "dropdown") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }
        // NUMBER SCALE
        if (question.type.toLowerCase() === "numberscale") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }

        // WONG BAKER
        if (response.questionType.toLowerCase() === "wongbaker") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }
        // MEDICATION SELECTOR
        if (response.questionType.toLowerCase() === "medicationselector") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }
        //AUDIO RECORDING
        if (response.questionType.toLowerCase() === "audiorecording") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }
        // VIDEO RECORDING
        if (response.questionType.toLowerCase() === "videorecording") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }
        // VAS
        if (response.questionType.toLowerCase() === "vas") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }
        // GPSKIN
        if (response.questionType.toLowerCase() === "gpskin") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }
        // Instruction
        if (response.questionType.toLowerCase() === "surveyinstruction") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }
        // SKIN ANALYSER
        if (response.questionType.toLowerCase() === "skinanalyser") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }
        // IMAGE CAPTURE
        if (response.questionType.toLowerCase() === "imagecapture") {
          this.tempEditedAnswers[response.questionId] = response[this.JsonFieldToDisplay];
        }
      });
    },

    getIntoEditMode() {
      // this.isEditModeActive = true;
      if (!!this.surveyData && this.surveyData.branchingConfigured && this.isParticipantActivity()) {
        this.$refs.branchingWarning.show();
      }
      this.$emit("changeEditMode", true);
      this.$emit("editModeActivated");
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    getQuestionSubType(id) {
      const question = this.questionDetailsObj && this.questionDetailsObj[id];

      if (!question) {
        return;
      }

      return question.subType || null;
    },

    cloneDeepParticipantResponses() {
      this.participantResponses = _.cloneDeep(this._participantResponses);

      this.participantResponses.forEach(response => {
        if (response.questionType.toLowerCase() === "multichoice") {
          if (this.getQuestionSubType(response.questionId) === "Multi") {
            response.displayAnswerText = response.displayAnswerText ? response.displayAnswerText.split(`, `) : [];
          }
        }
      });
    },

    onEditCancel() {
      // this.isEditModeActive = false;
      this.$emit("changeEditMode", false);
      this.cloneDeepParticipantResponses();
      this.setTempInitialValues();
    },

    getFieldErrors(questionId) {
      if (!this.errors) {
        return [];
      }

      return this.errors.items.filter(e => e.field === questionId);
    },

    // IMAGE

    getAllLanguageImages(questionId) {
      const languageImageUrls = this.questionDetailsObj[questionId].languageImageOptions.find(language => language.languageCulture === this.activityLanguageCulture);

      if (languageImageUrls) {
        return languageImageUrls.options;
      }

      const englishImageUrls = this.questionDetailsObj[questionId].languageImageOptions.find(language => language.languageCulture === "EN");

      if (englishImageUrls) {
        return englishImageUrls.options;
      }

      return [];
    },

    getImageSequence(questionId, imagesId) {
      const allOptions = this.getAllLanguageImages(questionId);
      if (typeof imagesId === "string") {
        return allOptions.find(option => option.id === imagesId).sequence;
      }

      if (imagesId instanceof Array) {
        return imagesId.map(id => {
          return allOptions.find(option => option.id === id).sequence;
        });
      }
    },

    getBodyOfOptions(questionId, selectedOptionsId) {
      const allOptions = this.questionIdToMLOptions[questionId].options;
      if (typeof selectedOptionsId === "string") {
        const foundOption = allOptions.find(option => selectedOptionsId === option.id);
        return foundOption.body;
      }

      if (selectedOptionsId instanceof Array) {
        const selectedOptionsArray = selectedOptionsId.map(selectedOptionId => {
          return allOptions.find(option => option.id === selectedOptionId);
        });
        selectedOptionsArray.sort((a, b) => a.sequence - b.sequence);
        return selectedOptionsArray.filter(option => option != null && option.body != null).map(option => option.body);
      }
    },

    getBodyOfLabels(questionId, selectedOptionsId) {
      const allOptions = this.questionIdToMLOptions[questionId].labels;
      const mlOptions = this.questionDetailsObj[questionId].labels;
      if (typeof selectedOptionsId === "string") {
        return allOptions[mlOptions.indexOf(selectedOptionsId)];
      }

      if (selectedOptionsId instanceof Array) {
        const selectedOptionsArray = selectedOptionsId.map(selectedOptionId => {
          return allOptions.find(option => option.id === selectedOptionId);
        });
        selectedOptionsArray.sort((a, b) => a.sequence - b.sequence);
        return selectedOptionsArray.map(option => option.body);
      }
    },

    sortOptionIdsBySequence(questionId, optionIds) {
      const question = this.questionDetailsObj[questionId];

      const qType = question.type.toLowerCase();
      let allOptions;

      if (qType === "multichoice") {
        allOptions = question.options;
      }
      // else  if (qType === 'boolean') {
      //     allOptions = question.options;
      // }
      else if (qType === "image") {
        allOptions = this.getAllLanguageImages(questionId);
      }
      const options = optionIds.map(option => {
        return allOptions.find(o => o.id === option);
      });

      options.sort((a, b) => a.sequence - b.sequence);

      return options.filter(o => o != null && o.id != null);
    },

    checkIfDateTimeIsEditedWhenSkipped(answer, questionId) {
      if (answer) {
        return true;
      }
      if (this.tempEditedAnswers[questionId] && this.tempEditedAnswers[questionId].date) {
        const { year, month, date } = this.tempEditedAnswers[questionId].date;
        if (month || year || date) {
          return true;
        }
      }

      if (this.tempEditedAnswers[questionId] && this.tempEditedAnswers[questionId].time) {
        const { HH, hh, mm, ss, A } = this.tempEditedAnswers[questionId].time.value;
        if (HH || hh || mm || ss || A) {
          return true;
        }
      }

      return false;
    },

    checkIfDateTimeIsEdited(editedResponse, previousResponse, questionId) {
      const question = this.questionDetailsObj[questionId];

      if (!editedResponse && !previousResponse) {
        return false;
      }

      if (question.showDate && question.showTime) {
        const editedResponseMoment = moment(editedResponse);
        const previousResponseMoment = moment(previousResponse);

        const isDateChanged = editedResponseMoment.date() !== previousResponseMoment.date();
        const isMonthChanged = editedResponseMoment.month() !== previousResponseMoment.month();
        const isYearChanged = editedResponseMoment.year() !== previousResponseMoment.year();
        const isHourChanged = editedResponseMoment.hour() !== previousResponseMoment.hour();
        const isMinutedChanged = editedResponseMoment.minutes() !== previousResponseMoment.minutes();
        const isSecondsChanged = editedResponseMoment.seconds() !== previousResponseMoment.seconds();

        if (isDateChanged || isMonthChanged || isYearChanged || isHourChanged || isMinutedChanged || isSecondsChanged) {
          return true;
        }

        return false;
      }

      if (question.showDate || question.showTime) {
        if (editedResponse === previousResponse) {
          return false;
        }
        return true;
      }
    },

    onEditConfirm() {
      const nonEditedAnswers = _.cloneDeep(this.participantResponses);
      this.participantResponses.forEach(response => {
        if (this.doesQuestionExistsInSurveyJson(response.questionId)) {
          if (response.displayAnswerText instanceof Array) {
            response.displayAnswerText = response.displayAnswerText.join(", ");
          }

          // DATE TIME

          if (response.questionType.toLowerCase() === "datetime") {
            const isChanged = this.checkIfDateTimeIsEditedWhenSkipped(response.displayAnswerText, response.questionId);

            if (isChanged) {
              const changedDateTime = this.getDateTimeChangedValues(response.questionId, response.displayAnswerText);
              response.answerText = changedDateTime;
              response.displayAnswerText = changedDateTime;
            } else {
              response.displayAnswerText = null;
            }
          }

          // CUSTOM SCALE
          if (response.questionType.toLowerCase() === "customscale") {
            if (!this.tempEditedAnswers[response.questionId]) {
              response.optionId = null;
              response.displayAnswerText = null;
            } else {
              const optionIds = this.tempEditedAnswers[response.questionId];
              const questionOptions = this.questionDetails.find(o => o.id == response.questionId);

              response.answerText = this.getBodyOfLabels(response.questionId, optionIds);
              response.optionId = questionOptions.labels.findIndex(o => o == this.tempEditedAnswers[response.questionId]);
              response.displayAnswerText = this.tempEditedAnswers[response.questionId];
            }
          }
          // MULTI CHOICE

          if (response.questionType.toLowerCase() === "multichoice") {
            if (!this.tempEditedAnswers[response.questionId]) {
              response.optionId = null;
              response.displayAnswerText = null;
            } else {
              // MULTI
              if (this.getQuestionSubType(response.questionId) === "Multi") {
                const optionIds = this.tempEditedAnswers[response.questionId];
                const optionsBody = this.getBodyOfOptions(response.questionId, optionIds);
                response.answerText = optionsBody.join(`, `);
                response.displayAnswerText = optionsBody.join(`, `);
                const optionIdsSorted = this.sortOptionIdsBySequence(response.questionId, optionIds).map(o => o.id);
                response.optionId = optionIdsSorted.join(",");
                if (this.selectedLanguageCulture != "EN") {
                  const allMultiLingualOptionBody = [];
                  optionIdsSorted.forEach(selectedOptionId => {
                    const questionOptions = this.questionDetails.find(o => o.id === response.questionId);
                    const multiLingualOption = questionOptions.options.find(o => o.id === selectedOptionId);
                    if (multiLingualOption) {
                      allMultiLingualOptionBody.push(multiLingualOption.body);
                    }
                  });
                  const displayAnswerText = allMultiLingualOptionBody.join(", ");
                  response.displayAnswerText = displayAnswerText;
                }
              }

              // SINGLE

              if (this.getQuestionSubType(response.questionId) === "Single") {
                const optionId = this.tempEditedAnswers[response.questionId];
                const body = this.getBodyOfOptions(response.questionId, optionId);
                response.displayAnswerText = String(body);
                response.answerText = String(body);
                response.optionId = optionId;
                let displayAnswerText = "";
                const questionOptions = this.questionDetails.find(o => o.id == response.questionId);
                const multiLingualOption = questionOptions.options.find(o => o.id == optionId);
                if (multiLingualOption) {
                  displayAnswerText = multiLingualOption.body;
                }
                response.displayAnswerText = displayAnswerText;
              }
            }
          }

          // IMAGE

          if (response.questionType.toLowerCase() === "image") {
            if (!this.tempEditedAnswers[response.questionId]) {
              response.optionId = null;
              response.displayAnswerText = null;
            } else {
              // MULTI
              if (this.getQuestionSubType(response.questionId) === "Multi") {
                const selectedImageIdsArray = this.tempEditedAnswers[response.questionId];
                const selectedImageIdsArraySorted = this.sortOptionIdsBySequence(response.questionId, selectedImageIdsArray);
                const imageSequence = this.getImageSequence(response.questionId, selectedImageIdsArray);
                imageSequence.sort((a, b) => a - b);
                response.answerText = imageSequence.join(`, `);
                response.displayAnswerText = imageSequence.join(`, `);
                response.optionId = selectedImageIdsArraySorted.map((item) => item.id).join(",");
              }

              // SINGLE
              if (this.getQuestionSubType(response.questionId) === "Single") {
                const selectedImageId = this.tempEditedAnswers[response.questionId];
                const imageSequence = this.getImageSequence(response.questionId, selectedImageId);
                response.answerText = imageSequence;
                response.displayAnswerText = imageSequence;
                response.optionId = selectedImageId;
              }
            }
          }

          // BOOLEAN

          if (response.questionType.toLowerCase() === "boolean") {
            if (!this.tempEditedAnswers[response.questionId]) {
              response.optionId = null;
              response.displayAnswerText = null;
            } else {
              const optionIds = this.tempEditedAnswers[response.questionId];
              const optionsBody = this.getBodyOfOptions(response.questionId, optionIds);
              response.answerText = String(optionsBody);
              response.displayAnswerText = String(optionsBody);
              response.optionId = optionIds;
              if (this.selectedLanguageCulture != "EN") {
                const allMultiLingualOptionBody = [];
                const questionOptions = this.questionDetails.find(o => o.id == response.questionId);
                const multiLingualOption = questionOptions.options.find(o => o.id == optionIds);
                if (multiLingualOption) {
                  allMultiLingualOptionBody.push(multiLingualOption.body);
                }

                const displayAnswerText = multiLingualOption.body;
                response.displayAnswerText = displayAnswerText;
              }
            }
          }

          // SURVEY INSTRUCTION
          if (response.questionType.toLowerCase() === "surveyinstruction") {
            response.answerText = response.displayAnswerText = this.tempEditedAnswers[response.questionId];
          }
          // SKIN ANALYSER
          if (response.questionType.toLowerCase() === "skinanalyser") {
            response.answerText = response.displayAnswerText = this.tempEditedAnswers[response.questionId];
          }
          // TEXT
          if (response.questionType.toLowerCase() === "text") {
            response.answerText = response.displayAnswerText = this.tempEditedAnswers[response.questionId];
          }
          // NUMBER
          if (response.questionType.toLowerCase() === "number") {
            response.answerText = response.displayAnswerText = this.tempEditedAnswers[response.questionId];
          }
          // NUMBER SCALE
          if (response.questionType.toLowerCase() === "numberscale") {
            response.answerText = response.displayAnswerText = this.tempEditedAnswers[response.questionId];
          }
          // DROP DOWN
          if (response.questionType.toLowerCase() === "dropdown") {
            response.answerText = response.displayAnswerText = this.tempEditedAnswers[response.questionId];
          }
          // WONG BAKER
          if (response.questionType.toLowerCase() === "wongbaker") {
            response.answerText = response.displayAnswerText = this.tempEditedAnswers[response.questionId];
          }
          // AUDIO RECORDING
          if (response.questionType.toLowerCase() === "audiorecording") {
            let audioAnswerList;
            if (this.tempEditedAnswers[response.questionId]) {
              audioAnswerList = JSON.parse(this.tempEditedAnswers[response.questionId]);
              if (audioAnswerList) {
                for (let i = 0; i < audioAnswerList.length; i++) {
                  const audioAnswer = audioAnswerList[i];
                  if (audioAnswer && audioAnswer.presignedURL) {
                    delete audioAnswer.presignedURL;
                  }
                }
              }
            }
            let answerText = JSON.stringify(audioAnswerList);
            response.answerText = response.displayAnswerText = answerText;
          }
          // VIDEO RECORDING
          if (response.questionType.toLowerCase() === "videorecording") {
            let videoAnswerList;
            if (this.tempEditedAnswers[response.questionId]) {
              videoAnswerList = JSON.parse(this.tempEditedAnswers[response.questionId]);
              if (videoAnswerList) {
                for (let i = 0; i < videoAnswerList.length; i++) {
                  const videoAnswer = videoAnswerList[i];
                  if (videoAnswer && videoAnswer.presignedURL) {
                    delete videoAnswer.presignedURL;
                    delete videoAnswer.thumbnailPresignedURL;
                  }
                }
              }
            }

            let answerText = JSON.stringify(videoAnswerList);
            response.answerText = response.displayAnswerText = answerText;
          }

          // GPSKIN
          if (response.questionType.toLowerCase() === "gpskin") {
            response.answerText = response.displayAnswerText = this.tempEditedAnswers[response.questionId];
          }
          // IMAGE CAPTURE
          if (response.questionType.toLowerCase() === "imagecapture") {
            response.answerText = response.displayAnswerText = this.tempEditedAnswers[response.questionId];
          }
          // VAS
          if (response.questionType.toLowerCase() === "vas") {
            response.answerText = response.displayAnswerText = this.tempEditedAnswers[response.questionId];
          }
          // MEDICATION SELECTOR
          if (response.questionType.toLowerCase() === "medicationselector") {
            let medicationAnswerList;
            if (this.tempEditedAnswers[response.questionId]) {
              medicationAnswerList = JSON.parse(this.tempEditedAnswers[response.questionId]);
              if (medicationAnswerList) {
                for (let i = 0; i < medicationAnswerList.length; i++) {
                  const medicationAnswer = medicationAnswerList[i];
                  if (medicationAnswer && medicationAnswer.previewImagesList) {
                    delete medicationAnswer.previewImagesList;
                  }
                }
              }
            }

            let answerText = JSON.stringify(medicationAnswerList);
            response.answerText = response.displayAnswerText = answerText;
          }
        }
      });

      this.participantResponses.forEach((response, index) => {
        const qType = response.questionType.toLowerCase();
        const questionWithDisplayAnswerText = ["number", "text", "customscale", "numberscale", "dropdown", "vas", "wongbaker"];
        const nonEditableQuestion = ["audiorecording", "imagecapture", "videorecording", "surveyinstruction"]
        const questionWithOptionIds = ["multichoice", "image", "boolean"]
        if (questionWithOptionIds.includes(qType)) {
          if (response.optionId != nonEditedAnswers[index].optionId) {
            response.editStatus = 1;
          } else {
            response.editStatus = 0;
          }
        } else if (questionWithDisplayAnswerText.includes(qType)) {
          if (response.displayAnswerText != nonEditedAnswers[index].displayAnswerText) {
            response.editStatus = 1;
          } else {
            response.editStatus = 0;
          }
        } else if (qType === "medicationselector") {
          if (response.displayAnswerText != JSON.stringify(JSON.parse(nonEditedAnswers[index].displayAnswerText))) {
            response.editStatus = 1;
          } else {
            response.editStatus = 0;
          }
        } else if (nonEditableQuestion.includes(qType)) {
          response.editStatus = 0;
        } else if (qType === "datetime") {
          let isDateTimeChanged = false;
          if (this.doesQuestionExistsInSurveyJson(response.questionId)) {
            isDateTimeChanged = this.checkIfDateTimeIsEdited(response.displayAnswerText, nonEditedAnswers[index].displayAnswerText, response.questionId);
          }

          if (isDateTimeChanged) {
            response.editStatus = 1;
          } else {
            response.editStatus = 0;
          }
        }
        response.surveyResponseTracker = this.updateActivityStatuses(response.surveyResponseTracker);
      });

      this.participantResponses = this.participantResponses.filter(ans => {
        return ans.isDisabled != true;
      });

      const changeReason = this.changeReason;
      const selectedQuery = this.selectedQuery ? this.selectedQuery : "";
      const requestBody = {
        responses: this.participantResponses,
        reason: changeReason,
        queryId: selectedQuery
      };
      if (this.studyData && !!this.studyData.activityAllowed) {
        requestBody.activityId = this.surveyData.activityId;
      }
      this.$emit("onConfirmEdit", {
        requestBody,
        done: () => {
          // this.isEditModeActive = false
          this.$emit("changeEditMode", false);
          this.hideConfirmEditModal();
        }
      });
    },

    updateActivityStatuses(responseTracker) {
      const surveyResponseTracker = responseTracker || {};
      const currentTime = new moment().utc().format("YYYY-MM-DD HH:mm:ss");
      const userId = this.user && this.user.id;

      const activityStatusesUpdatedData = {
        verificationStatus: "unverified",
        verifiedBy: userId,
        verifiedTime: currentTime,
        approvalStatus: "unapproved",
        approvedBy: userId,
        approvedTime: currentTime,
        signoffStatus: "PENDING",
        signoffBy: userId,
        signoffTime: currentTime,
        reviewStatus: "UNREVIEWED",
        reviewBy: userId,
        reviewTime: currentTime
      };

      return {
        ...activityStatusesUpdatedData,
        ...surveyResponseTracker
      };
    },

    findMissingAnswers(questionsOld, answers) {
      let questions = questionsOld;
      questions = questions.filter(que => {
        return que.type != "Section" && que.type != "SurveyCompletion" && que.type != "Measurements" && que.type != "Index" && que.type != "Log" && que.type != "ValidatedEntry";
      });

      const notAnswered = questions.map(que => {
        if (answers.some(ans => ans.questionId == que.id) == false) {
          return que;
        }
      });
      const missedQuestions = notAnswered.filter(el => el != undefined);
      this.createObjectForMissed(missedQuestions, questions, answers);
    },
    createObjectForMissed(missedQuestions, questions, answers) {
      missedQuestions.forEach(missedQuestion => {
        const answerTemplate = Object.assign({}, answers[0]);
        answerTemplate.answerText = null;
        answerTemplate.displayAnswerText = null;
        answerTemplate.optionId = missedQuestion.id;
        answerTemplate.isQrCode = null;
        answerTemplate.computedScore = 0;
        answerTemplate.score = 0;
        answerTemplate.questionType = missedQuestion.type;
        answerTemplate.questionId = missedQuestion.id;
        answerTemplate.displayQuestionText = missedQuestion.formattedBody;
        answerTemplate.questionText = answerTemplate.questionBody = this.stripHTML(missedQuestion.formattedBody);
        answerTemplate.isSkipped = missedQuestion.isSkipped;
        answerTemplate.sequence = missedQuestion.stepSequence;
        answerTemplate.isDisabled = true;
        answerTemplate.isResponseMissing = true;

        this.participantResponses.push(answerTemplate);
      });
      this.participantResponses = _.sortBy(this.participantResponses, "sequence");
    },
    stripHTML(data) {
      if (data == null) {
        return;
      }
      const regex = /(<([^>]+)>)/gi;
      return data.replace(regex, "");
    },
    getDateTimeChangedValues(questionId, answer) {
      const question = this.questionDetailsObj[questionId];

      if (question.showDate && question.showTime) {
        let originalDateTimeMoment = moment(answer, "YYYY-MM-DDTHH:mm:ss.SSSZZ");

        if (!originalDateTimeMoment.isValid()) {
          originalDateTimeMoment = moment();
        }

        const changedDate = this.tempEditedAnswers[questionId].date;
        originalDateTimeMoment.set("year", changedDate.year);
        originalDateTimeMoment.set("month", changedDate.month);
        originalDateTimeMoment.set("date", changedDate.date);

        const changedTime = this.tempEditedAnswers[questionId].time.value;

        if (question.timeFormat == 12) {
          const HH = moment(`${changedTime.hh} ${changedTime.A}`, ["h A"]).format("HH");

          originalDateTimeMoment.set("hour", HH);
        } else {
          originalDateTimeMoment.set("hour", changedTime.HH);
        }
        originalDateTimeMoment.set("minute", changedTime.mm);
        originalDateTimeMoment.set("second", changedTime.ss);
        return originalDateTimeMoment.format("YYYY-MM-DDTHH:mm:ss.SSSZZ");
      }

      if (question.showDate) {
        const { year, month, date } = this.tempEditedAnswers[questionId].date;

        // month is 0 based index and in string we need 1 based index so doing +1 to month

        const dateString = `${year}-${month + 1}-${date}`;

        const dateStringMoment = moment(dateString, "YYYY-M-DD").format("YYYY-MM-DD");

        return dateStringMoment;
      }

      if (question.showTime) {
        const changedTime = this.tempEditedAnswers[questionId].time.value;

        return this.convertTimeObjectToString(changedTime, question.timeFormat);
      }
    },
    convertTimeObjectToString(timeObject, timeFormat) {
      if (timeFormat == 12) {
        const { hh, mm, A } = timeObject;
        if (hh && mm && A) {
          return `${hh}:${mm} ${A}`;
        }
        return "";
      } else if (timeFormat == 24) {
        const { HH, mm } = timeObject;
        if (HH && mm) {
          return `${HH}:${mm}`;
        }
        return "";
      }
    },

    createNewQuery(questionId) {
      this.$emit("openNewQuery", questionId);
    },
    roundOffToThreeDigits(value) {
      if (value) {
        const val = parseFloat(value).toFixed(1);
        return val > 0.0 ? val : 0;
      }
    },
    hideBranchingWarningModal(editMode) {
      this.$refs.branchingWarning.hide();
      this.$emit("changeEditMode", editMode);
    },
    isParticipantActivity() {
      if (this.surveyData) {
        if (this.surveyData.completePermissions) {
          return this.surveyData.completePermissions.includes("Patient/Participant");
        }
      }
      return false;
    },
    getUpdatedQuestionResponses() {
      if (this.surveyData && this.surveyData.questions) {
        const result = this.surveyData.questions.filter(object1 => !this.participantResponses.some(object2 => object1.id === object2.questionId));
        if (result) {
          result.forEach(r => {
            if (r.type !== "SurveyCompletion" && r.type !== "Section") {
              this.participantResponses.push({
                questionBody: r.body,
                questionInformation: null,
                answerText: null,
                questionId: r.id,
                questionType: r.type,
                sequence: r.sequence,
                appLanguageId: this.participantResponses[0].appLanguageId,
                displayLanguage: this.participantResponses[0].displayLanguage,
                displayQuestionText: r.formattedBody,
                displayAnswerText: null
              });
            }
          });
          this.participantResponses = _.sortBy(this.participantResponses, "sequence");
        }
      }
    },
  }
};
</script>

<style lang="scss">
.participant-activity-response {
  .answer-container {
    .answer {
      .custom-control {
        min-height: 2rem;
      }

      .form-control:disabled,
      .form-control[readonly] {
        background-color: #ffffff;
      }

      .vdp-datepicker {
        div {
          height: 100%;

          input {
            height: 100%;
          }
        }
      }

      .vertical-vue-slider {
        height: 300px !important;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}

.modal-content-box {
  height: 255px;
}
.que-ans-heading {
  height: 50px;
  background-color: #f9f9fb;
  padding-right: 32px;

  .change-reason-text {
    color: #000000;
  }

  &__left,
  &__right {
    height: 100%;
    padding-top: 15px;
  }

  &__left {
    padding-left: 32px;
    width: calc(40% - 32px);
  }

  &__right {
    padding-left: 58px;
    flex-grow: 1;
  }

  &__line {
    width: 2px;
    height: 100%;
    background-color: #ffffff;
  }
}

.create-query-btn-container {
  display: flex;
  align-items: center;
  width: 120px;
  align-self: center;
  border-bottom: 1px solid #efefef;
  position: absolute;
  right: 10px;
  transform: translateY(-50%);
}

.participant-response__fields-list {
  max-height: 88vh;
  overflow: auto;

  .participant-response__field {
    min-height: 80px;

    .open-query-indicator-container {
      width: 30px;
      text-align: center;

      .open-query-indicator {
        width: 13px;
        height: 13px;
        display: inline-block;
        border-radius: 50%;
        background-color: #f5a623;
      }
    }

    .question-answer-container {
      width: 100%;
      /* width: calc(100% - 64px); */
      flex-basis: calc(100% -64px);
      border-bottom: 1px solid #efefef;
      padding-bottom: 20px;
      padding-right: 50px;

      .question-container {
        width: 35%;
        flex-basis: 35%;

        .question-container__question-label {
          font-size: 12px;
          font-weight: bold;
        }

        .index-no {
          width: 20px;
        }
      }

      .answer-container {
        width: 65%;
        flex-basis: 65%;
        min-height: 100%;
        padding-left: 32px;

        .answer {
          height: 100%;
        }
      }
    }
  }
}

.save-btn {
  cursor: pointer;
  width: 85px;
  height: 34.2px;
  border-radius: 3px;
  border: solid 1px #ffffff;
  background-color: #4c8ce4;
}
.save-btn-text {
  width: 83.9px;
  height: 29.7px;
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.cancel-edit-btn {
  cursor: pointer;
  width: 85px;
  height: 34.2px;
  border-radius: 3px;
  border: solid 1px #ffffff;
  background-color: #ffffff;
}

.cancel-edit-btn-text {
  width: 83.9px;
  height: 29.7px;
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.edit-btn-after {
  cursor: pointer;
  width: 83px;
  height: 24px;
  border-radius: 3px;
  border: solid 1px #d7dfeb;
  background-color: #ffffff;
}
.edit-btn-after-text {
  width: 37px;
  height: 19px;
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.edit-btn {
  cursor: pointer;
  width: 83px;
  height: 24px;
  border-radius: 3px;
  border: solid 1px #4c8ce4;
  background-color: #4c8ce4;
}
.edit-btn-text {
  width: 37px;
  height: 19px;
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}

.participant-response__img-response {
  width: 90px;
  height: 100px;
}

/* EDIT MODE */

.image-edit-mode {
  &__checkbox {
    left: 5px;
    top: 5px;
  }

  &__image {
    width: 90px;
    height: 90px;
  }
}

.number-edit-mode {
  width: 50%;
}

.participant-responses-last-empty-div {
  height: 250px;
}

/* MODAL */

.custom-select-modal-title {
  text-align: center;
  height: 50px;
  /* font-family: Robotobold; */
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}
.confirm-change {
  cursor: pointer;
  width: 174px;
  height: 38.7px;
  border-radius: 4px;
  border: solid 1px #ffffff;
  background-color: #4c8ce4;
}
.confirm-change-text {
  width: 171.8px;
  height: 33.7px;
  /* font-family: RobotoBold; */
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.custom-select-modal {
  width: 656px;
  height: 278px;
  border-radius: 4px;
  background-color: #ffffff;
}

.custom-select {
  background: #ffffff url(/static/img/arrow-down.png) no-repeat;
  width: 447px;
  height: 40.7px;
  border-radius: 3px;
  border: solid 2px #d3dfe4;
}

.save-btn {
  cursor: pointer;
  width: 85px;
  height: 34.2px;
  border-radius: 3px;
  border: solid 1px #ffffff;
  background-color: #4c8ce4;
}
.save-btn-text {
  width: 83.9px;
  height: 29.7px;
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.cancel-confirm-btn {
  cursor: pointer;
  width: 85px;
  height: 34.2px;
  border-radius: 3px;
  border: solid 1px #ffffff;
  background-color: #ffffff;
}

.cancel-confirm-btn-text {
  width: 83.9px;
  height: 29.7px;
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.open-new-query-btn {
  width: 114px;
  height: 24px;
  border: 1px solid #d7dfeb;
  font-family: "RobotoRegular";
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4c8ce4;
  background-color: #ffffff;
  text-transform: uppercase;
  border-radius: 3px;
  padding: 2px 5px;
  cursor: pointer;
}

/* UTILS */

.bg-f9f9e0 {
  background-color: #f9f9e0;
}
.font-w-bold {
  font-weight: bold !important;
}
.color-black {
  color: #000000;
}
.color-white {
  color: #ffffff;
}
button {
  outline: none;
}
.h-100-percent {
  height: 100%;
}
.disable-btn {
  cursor: not-allowed;
}
.selectBox {
  position: relative;
  border: 1px solid lightgray;
  border-radius: 4px;
}
.selectedBox {
  padding: 8px;
  text-align: left;
}
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(90%);
}
.selected-filter {
  width: 80%;
  cursor: pointer;
}
.query-type-select {
  width: 100%;
  font-size: 12px;
  border: none;
  height: 35px;
  border-radius: 3px;
  background-color: #ffff;
  color: #666669;
}
.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.query-search-bar {
  width: 100%;
  height: 33px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #ffffff;
  margin-bottom: 10px;
}
.query-list {
  width: 100%;
  cursor: pointer;
}

.query-list:hover {
  background-color: #1e8fe1;
  color: white !important;
}

#showQueries {
  background: #fff;
  position: absolute;
  width: 93%;
  border-radius: 3px;
  padding: 10px;
  z-index: 3;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  overflow-y: scroll;
  max-height: 300px;
  top: 3%;
}
#showQueries label {
  float: left;
  margin-bottom: 0px;
}

.branching-warning-text {
  line-height: 1.28;
  letter-spacing: normal;
  text-align: center;
  color: #666669;
}

.branching-warning-content {
  padding-bottom: 33px;
  padding-top: 30px;
}

.branching-modal-content {
  width: 483px;
  height: 225px;
}

.close-button {
  margin-right: -16px;
  margin-top: -5px;
}

button.btn.branching-modal-cancel-btn.btn-outline-primary {
  background: white;
  border: solid 1px #b0bac9;
  color: #4c8ce4;
}
button.btn.branching-modal-continue-btn.btn-primary {
  background-color: #4c8ce4;
  border-color: #4c8ce4;
}
</style>
